export default __webpack_public_path__ + "static/media/profile_bg.68db3cb3.png";